import CTA13_morph_bottom from './CTA13_morph_bottom'
export default CTA13_morph_bottom
